import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {environment} from '../../../../src/environments/environment';
import {ReactiveServiceWithFilters} from '../reactive-service-with-filters.abstract';

import {MultipleRESTService} from '../../../../src/app/API/apiService';
import {BusinessContrparamModel} from './businesscontrparam.model';

@Injectable()
export class BusinessContrparamsApiService extends ReactiveServiceWithFilters  implements MultipleRESTService<BusinessContrparamModel[]> {
  protected baseUrl = environment.backEndUrlPrefix + '/' + 'dwh/businessparam';

  constructor(protected http: HttpClient) {
    super();
  }

  getAll(): Observable<BusinessContrparamModel[]> {
    return this.http.get<BusinessContrparamModel[]>(this.buildUrl(this.baseUrl));
  }

  add(params: BusinessContrparamModel[]): Observable<BusinessContrparamModel[]> {
    return this.http.post<BusinessContrparamModel[]>(this.buildUrl(this.baseUrl), params);
  }

  updateGroup(ids: number[], data): Observable<BusinessContrparamModel[]> {
    return this.http.patch<BusinessContrparamModel[]>(this.baseUrl, data, {params: {id: ids.map(id => id.toString())}});
  }

  deleteGroup(ids: BusinessContrparamModel[]): Observable<string> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: ids,
    };
    return this.http.delete<string>(this.buildUrl(this.baseUrl), options);
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BusinessContrparamModel[]> | Promise<BusinessContrparamModel[]> | BusinessContrparamModel[] {
    this.params.businessparamId = route.params.businessparamId;
    return this.getAll();
  }

  protected initFilters() {
    super.initFilters();
    this.filters = {
      businessparamId: ':value/contrparams'
    };
  }
}
